<app-user-header></app-user-header>

<div class="container-fluid container-m-t">
    <div class="row">
        <div class="col-sm-3 left-panel-mobile-view">
            <div class="row h-105">
                <!-- left sidebar -->
                <div class="col-md-10 fixed pl-0 py-2 left left-sidebar">
                    <ul class="nav flex-md-column flex-nowrap justify-content-center m-l-ipad">
                        <li class="img-circle-styles" style="text-align: center; margin-top: 34px;"><img
                                style="    border: 1px solid #FFF;border-radius: 49%;width: 40%;height: 40%;"
                                src="assets/images/user-image.png" class="img-circle" alt="Cinque Terre">
                            <h5 class="center user-text" style="text-align:  center;">
                                {{ramki.firstName + "  "+ ramki.lastName}}</h5>
                        </li>

                        <!-- <li>
                                    <a class="nav-link">
                                        <form [formGroup]="form" class="form-styles">
                                            <div class="form-group">
                                                <label for="year">Tax Year</label>
                                                <select #mySelected class="form-control" value="data[0]" (change)='onOptionsSelected(mySelected.value)'>
                                                    <option disabled>Select Year</option>
                                                    <option *ngFor="let yr of data">{{yr}}</option>
                                                </select>
                                                <div *ngIf="f.year.touched && f.year.invalid" class="alert alert-danger">
                                                    <div *ngIf="f.year.errors.required">Please Select Tax Year</div>
                                                </div>
                                            </div>
                                        </form>
                                    </a>
                                </li> -->
 
                        <!-- <button class="navbar-toggler ml-auto py-2" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                                    ☰
                                </button> --> 
                        <!-- class="collapse navbar-collapse" id="collapsingNavbar" -->
                          <div>
                            <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard"
                                style="background: black;">
                                <a class="nav-link font-size-ipad" routerLink="/dashboard">
                                    <img src="assets/images/dashboard.svg" style="width: auto; height: auto;">&nbsp;
                                    <span class="nav-link-text sidebar-text" style="color: white;">Dashboard</span>
                                </a>
                            </li><br>

                            <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Basic Information">
                                <a class="nav-link font-size-ipad" routerLink="/basic">
                                    <img src="assets/images/information.svg" style="width: auto; height: auto;">&nbsp;
                                    <span class="nav-link-text sidebar-text">Basic Information</span>
                                </a>
                            </li><br>
                            <li class="nav-item" data-toggle="tooltip" data-placement="right" title="My Documents">
                                <a class="nav-link font-size-ipad" routerLink="/documents">
                                    <img src="assets/images/doc.svg" style="width: auto; height: auto;">&nbsp;
                                    <span class="nav-link-text sidebar-text">My Documents</span>
                                </a>
                            </li><br>
                            <li class="nav-item" data-toggle="tooltip" data-placement="right"
                                title="Download Tax Return">
                                <a class="nav-link font-size-ipad" routerLink="/download">
                                    <img src="assets/images/tax.svg" style="width: auto; height: auto;">&nbsp;
                                    <span class="nav-link-text sidebar-text">Download Tax Return</span>
                                </a> 
                            </li><br>
                            <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Make Payment">
                                <a class="nav-link font-size-ipad" routerLink="/payment">
                                    <img src="assets/images/payment.svg" style="width: auto; height: auto;">&nbsp;
                                    <span class="nav-link-text sidebar-text">Make A Payment</span>
                                </a>
                            </li><br>
                            <li class="nav-item" data-toggle="tooltip" data-placement="right"
                                title="Consent Of Disclosure">
                                <a class="nav-link font-size-ipad" routerLink="/disclosure">
                                    <img src="assets/images/disclosure.svg" style="width: auto; height: auto;">&nbsp;
                                    <span class="nav-link-text sidebar-text">Consent Of Disclosure</span>
                                </a>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
        <!-- <div class="col-sm-1"></div> -->
        <div class="col-sm-9 col-m-t">
            <div class="dash-row">Dashboard</div>
            <br>

            <div class="steps">
                <h2>Get your taxes Filed in simple 3 steps</h2>
            </div>

            <div>
                <h3>Step 1 :</h3>

                <ul>
                    <li>
                        Filled Tax Organizer<br>
                    </li>
                    <li>Form W2 Statement – Received from all employers that you have worked. <br></li>
                    <li>1099 INT/DIV – Interest/Dividend Income - Please provide the document <br></li>
                    <li>1099-G : State Refunds received in year 2020 for filing 2019 tax returns <br></li>
                    <li>1099-B: Sales of Stock/Securities, Mutual Funds, etc. <br></li>
                    <li>1099-R : Income from Pension, IRAs and Annuities <br></li>
                    <li>K-1 : Partnerships, Trusts, Estates and S-Corporations <br></li>
                    <li>1098 T: Scholarships, Fellowships and Grants Form 1042 S, Form 1098 T/ <br></li>
                    <li>Rental Income (if any in India or USA) <br></li>
                    <li>INDIAN Interest income if any <br></li>

                </ul>
            </div>

            <br>

            <div>
                <h3>Step 2 :</h3>
                <p>
                    Give us 24 -36 Hours to analyze your tax notes and documents that you have uploaded to prepare and
                    analyst the
                    best return to maximize the Refund within the preview of the IRS guidelines
                </p>
            </div>

            <br>

            <div>
                <h3>Step 3 :</h3>
                <p>
                    Make payment and file your taxes with Federal, State and city department as they may applicable in
                    your case.You
                    will receive a confirmation upon filing your taxes within 24 – 36 Hours**
                </p>
                <p>
                    Are not these 3 simple steps to file your taxes from anywhere in this world with respective
                    departments of USA, you
                    need not visit any other TAX Consultants nor any Local CPA, NO wasting TIME, sitting at your home or
                    office you can
                    file taxes, we will guide you to file taxes without any hassle.
                </p>
            </div>

            <div class="footer" style="text-align: center;background-color: #e9ecef;
                line-height: 55px; color: black;">
                Copyright ©2020 Evolvtax Services Pvt Ltd. All rights reserved
            </div>
        </div>
    </div>
</div>